module.exports = __webpack_public_path__ + "img/banner.b2b5f9bb.jpg";